import Services from './service';

export default class Auth {

  login = (payload) => {
    Services.postLogin(payload)
      .then(res => {
        this.handleAuthentication(res);
      })
      .catch(err => console.log(err));
  }

  handleAuthentication(res) {
    console.log(res);
    if(res){
      this.setSession(res);
      window.location.replace('/');
    }
  }

  setSession(authResult) {
    // Set the time that the access token will expire at
    localStorage.setItem('token', authResult.token);
  }

  logout() {
    // Clear access token and ID token from local storage
    localStorage.removeItem('token');
    window.location.replace('/user/login');
  }

  isAuthenticated() {
    // Check whether the current time is past the 
    // access token's expiry time
    let token = localStorage.getItem('token');
    // return new Date().getTime() < expiresAt;
    if(token) {
      return true;
    } else {
      return false;
    }
  }
}
